import {CompanyReferralIncentiveDetail} from './companyReferralIncentiveDetail';

export class CompanyReferralIncentive {
    public companyReferralIncentiveName: string = 'NA';
    public companyReferralIncentiveDesc: string = '';
    public termsAndConditions: string = '';
    public companyReferralIncentiveDetails: CompanyReferralIncentiveDetail[] = [];
    public startDTTM: number = 0;
    public endDTTM: number = 0;
}
